module.exports = __webpack_public_path__ + "img/jiancedian.d53c20a8.png";